import { render, staticRenderFns } from "./PerformerMusicItem.vue?vue&type=template&id=a392084c&scoped=true&"
import script from "./PerformerMusicItem.vue?vue&type=script&lang=js&"
export * from "./PerformerMusicItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerMusicItem.vue?vue&type=style&index=0&id=a392084c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a392084c",
  null
  
)

export default component.exports